import { IProductForm } from "@utils/Interfaces";
import { apiClient } from "./ApiConfig";

export const ProductApi = {
  ProductRegistration: (body: IProductForm) => {
    return apiClient.post("/product", body);
  },
  GetMyProducts: () => {
    return apiClient.get("/product");
  },
  GetProductDetail: (id: number) => {
    return apiClient.get(`/product/get_product?product_id=${id}`);
  },
  GetAll: () => {
    return apiClient.get("/product/get_all");
  },
  GetPaginated: (current: number, pageSize: number) => {
    return apiClient.get(
      `/product/get_all/paginated?page=${current}&limit=${pageSize}`
    );
  },
  EsimateHay: (body: any) => {
    return apiClient.post("/product/estimate", body);
  },
  NearBy: (lat: number, lon: number) => {
    return apiClient.get(`/product/nearby?lat=${lat}&lon=${lon}&radius=500000`);
  },
  FilterProduct: (body: any) => {
    return apiClient.post(`/product/filter`, body);
  },
  Search: (body: any) => {
    return apiClient.post("/product/v4/search", body);
  },
  GetMetric: (hayType: string, shape?: string) => {
    return apiClient.get(`/product/v2/get_metrics?hay_type=${hayType}&shape=${shape}`);
  },
  Order: (body: any) => {
    return apiClient.post("/order/apply_all", body);
  },
  GetOrder: () => {
    return apiClient.get("/order");
  },
  GetProducerOrder: () => {
    return apiClient.get("/order/producer");
  },
  UpdateStatus: (body: any) => {
    return apiClient.post("/order/status", body);
  },
  RePostProduct: (body: any) => {
    return apiClient.post("/product/duplicate", body);
  },
  DeleteProduct: (body: any) => {
    return apiClient.post("/product/v2/delete_product", body);
  },
  UpdateProduct: (body: any) => {
    return apiClient.post("/product/update_product", body);
  },
};
